import { camelCase } from 'change-case/keys'

import type { CamelCased } from '../types/requests.types'

export const transformKeysToCamelCase = <T>(data: T, depth = 20) =>
  camelCase(data, depth) as CamelCased<T>
